import { useEffect, useState, FunctionComponent, MouseEvent } from 'react'

import getUrl from 'front-end-core/core/url'
import { QA_CONTENT, QA_MENU } from 'constants/controllers'
import Icon from 'components/shared/Icon'
import { FLAVOUR_COLORS } from 'constants/flavours'
import { Flavour } from 'types/Flavour'

const Title:FunctionComponent<TitleProps> = ({
  section,
  aol,
  flavour,
  expandedNodeTitle,
  sectionId,
  sectionsMap,
  handleExpandedTitleOnClick,
  isProxy = false
}) => {
  const [sectionTitle, setSectionTitle] = useState(section)
  const sectionUrl = getUrl(QA_CONTENT, { aol, flavour, sectionId })

  const handleSectionBreadcrumbOnClick = (e: MouseEvent) => {
    handleExpandedTitleOnClick(e)
    const sectionUrl = getUrl(QA_CONTENT, { flavour, sectionId })
    history.pushState({}, null, sectionUrl)
  }

  useEffect(() => {
    if (isProxy && sectionId && sectionsMap && sectionsMap.has(sectionId)) {
      const qaSection = sectionsMap.get(sectionId)
      setSectionTitle(qaSection.title)
    }
  }, [isProxy, section, setSectionTitle, sectionId, sectionsMap])
  // {'<'} is used to show that we are deliberately using angle braces as text and haven't just malformed our html (also linter)
  return (
    <div className='pt9 pb2 layout-width-constraint'>
      <div className='flex items-center flex-wrap f5 f6-t'>
        <div className='relative flex items-center'>
          <Icon name='icon-qa-search' className='w7 mr4' />
          <a
            className='black no-underline hover-underline hover-cadet-blue'
            href={getUrl(QA_MENU, { aol, flavour })}
            data-event-category='Q&amp;A'
            data-event-action='Back to menu'
            data-help-item='qareturn'
            data-help-position='bottom'
          >
            Q&A
          </a>
          <div className='mh4'>{'>'}</div>
        </div>
        {!expandedNodeTitle &&
          <div className='flavoured' style={{ color: FLAVOUR_COLORS[flavour] }}>
            <span>{sectionTitle}</span>
          </div>}
        {expandedNodeTitle &&
          <div className='flex items-center flex-wrap'>
            <div className='flex items-center'>
              <a
                className='black pointer no-underline hover-underline hover-cadet-blue'
                href={sectionUrl}
                onClick={handleSectionBreadcrumbOnClick}
                data-event-category='Q&amp;A'
                data-event-action='Breadcrumb Navigation'
                data-event-label={`${expandedNodeTitle} back to ${sectionTitle}`}
              >
                {sectionTitle}
              </a>
              <span className='mh4'>{'>'}</span>
            </div>
            <div className='flavoured' style={{ color: FLAVOUR_COLORS[flavour] }}>
              {expandedNodeTitle}
            </div>
          </div>}
      </div>
    </div>
  )
}

interface TitleProps {
  section: string;
  aol: string;
  flavour: Flavour;
  expandedNodeTitle: string;
  sectionId: string;
  sectionsMap: Map<string, {title: string}>,
  handleExpandedTitleOnClick: (event: MouseEvent) => void
  isProxy: boolean;
}

export default Title
